﻿import axios from 'axios';
import { get } from './api-client';

export const productService = {
    getProductDetails: (id) => get(`/Product/GetProductDetails/${id}`),

    getInstallationGuides: () => get(`/Product/GetInstallationGuides`),

    addProductToCompareList: (id) => get(`/Product/AddProductToCompareList/${id}`),

    getCompareProducts: () => get('/Product/CompareProducts'),

    removeProductFromCompareList: (id) => get(`/Product/RemoveProductFromCompareList/${id}`),

    getHomePageProducts: () => get('/Product/HomePageProducts'),

    getProductDataSheet: (productId, isMetric) => axios.get(`/product/getProductDataSheet/${productId}/${isMetric}`, { responseType: "blob" })
};